module.exports = __webpack_public_path__ + "img/imagen10.6a4afc8d.png";